import {dateReader, localDateSender} from 'helpers/UnitsFormatHandler';
import useParseURL from './useParseURL';
import {useGetPlan} from 'hooks/swr';
import {useFilterContext} from 'context/FilterContext';

const useGetLongTermRange = () => {
  const {planId} = useParseURL();

  const {data: plan} = useGetPlan({resourceId: planId});
  const filterContext = useFilterContext();

  const _startDate = filterContext.longTermViewSelectedPeriod?.startDate
    ? filterContext.longTermViewSelectedPeriod?.startDate
    : plan?.startDate;
  const _endDate = filterContext.longTermViewSelectedPeriod?.endDate
    ? filterContext.longTermViewSelectedPeriod?.endDate
    : plan?.endDate;

  const startDate = _startDate ? dateReader(_startDate) : undefined;
  const endDate = _endDate ? dateReader(_endDate) : undefined;

  const setPeriod = (period: {startDate?: Date; endDate?: Date}) =>
    (filterContext.longTermViewSelectedPeriod = {
      startDate: period?.startDate ? localDateSender(period?.startDate) : '',
      endDate: period?.endDate ? localDateSender(period?.endDate) : '',
    });

  return {startDate, endDate, setPeriod, plan};
};

export default useGetLongTermRange;
